module.exports = __webpack_public_path__ + "static/mabry-medium-pro-80f79d2aa7e32903f63de575e79f9d68.ttf";